__webpack_require__.p = "/knowledge-hub/assets/";